'use client';

import Image from 'next/image';
import { EmailForm } from './EmailForm';

interface HeroProps {
  title?: string;
  subtitle?: string;
  ctaText?: string;
}

export function Hero({
  title = "Spark Bedtime Magic: Personalized AI Stories Your Child Will Love",
  subtitle = "Effortlessly create enchanting, personalized bedtime stories that captivate your child's imagination and make bedtime a joy.",
  ctaText = "Join the Waitlist for Early Access",
}: HeroProps) {
  return (
    <section className="bg-white">
      <div className="container mx-auto px-4 py-16 sm:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-[#FF8B6B] to-[#FF5D3A] bg-clip-text text-transparent">
              {title}
            </h1>
            <p className="text-lg sm:text-xl mb-8 text-gray-600">
              {subtitle}
            </p>
            <EmailForm ctaText={ctaText} />
          </div>
          <div className="relative group">
            <div className="relative aspect-[4/3] transform group-hover:scale-[1.02] transition-transform duration-300">
              <Image
                src="/images/logo.jpg"
                alt="Lullaby Bunny - AI-Powered Bedtime Stories"
                width={800}
                height={600}
                quality={100}
                className="rounded-2xl shadow-xl object-contain hover:shadow-2xl transition-shadow duration-300"
                priority
                placeholder="blur"
                blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRseHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/2wBDAR4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
              />
            </div>
            <div className="mt-6 text-center">
              <p className="text-base sm:text-lg text-gray-600">
                Trusted by parents who believe in magical bedtime moments
              </p>
              <div className="flex justify-center mt-3">
                <div className="flex -space-x-3">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="w-10 h-10 rounded-full border-2 border-white overflow-hidden"
                    >
                      <Image
                        src={`/avatars/avatar-${i}.jpg`}
                        alt={`Parent ${i}`}
                        width={40}
                        height={40}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 